import { useMutation } from "@tanstack/react-query";
import { handleGoogleOAuthCallback } from "../../api/bReviewsApi";

export const useHandleGoogleOAuthCallback = () => {
  return useMutation({
    mutationKey: ["handle-google-oauth-callback"],
    mutationFn: (data) => handleGoogleOAuthCallback(data),
    onError: (error) => {
      console.error("Google OAuth callback error:", error.response || error);
    },
  });
};
